import {
  Component,
  ChangeDetectionStrategy,
  input,
  output,
  computed,
  viewChild
} from '@angular/core';
import { CdkOverlayOrigin } from '@angular/cdk/overlay';
import { MatIcon } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslocoPipe } from '@jsverse/transloco';
import { Constraint } from '@htx/policies';
import { TYPE_META, CATEGORY_COLORS } from '../../shared/constraint-metadata';

@Component({
  selector: 'app-constraint-chip',
  imports: [CdkOverlayOrigin, MatIcon, MatTooltipModule, TranslocoPipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './constraint-chip.component.html',
  styleUrl: './constraint-chip.component.scss'
})
export class ConstraintChipComponent {
  readonly constraint = input.required<Constraint>();
  readonly configured = input(false);
  readonly active = input(false);
  readonly static = input(false);
  readonly locked = input(false);

  /** Emits the CdkOverlayOrigin so the parent can anchor the popover. */
  readonly edit = output<CdkOverlayOrigin>();
  readonly remove = output<void>();

  /** Expose the overlay origin for the parent to use. */
  readonly chipOrigin = viewChild.required<CdkOverlayOrigin>('chipOrigin');

  readonly meta = computed(() => {
    const m = TYPE_META.get(this.constraint().type);
    return m ?? { icon: 'help', labelKey: 'Unknown', category: 'access' as const };
  });

  readonly categoryColor = computed(() =>
    CATEGORY_COLORS[this.meta().category] ?? '#8c95a6'
  );

  onEdit(): void {
    this.edit.emit(this.chipOrigin());
  }
}
